import React from 'react';
import { useEffect, useState } from 'react';
import { Button, Table, Radio, Tooltip, Row, Col, Spin } from 'antd';
import ReactMarkdown from 'react-markdown'
import { FaTwitter, FaDiscord, FaGlobe, FaEthereum, FaInstagram, FaTelegram, FaShieldAlt } from 'react-icons/fa';
import { GiSailboat } from 'react-icons/gi';


function ContractDetails({ address }) {
    const [loading, setLoading] = useState(false);
    const [pairLoading, setPairLoading] = useState(false);
    const [contract, setContract] = useState({});
    const [pair, setPair] = useState({});

    const fetchPairStats = async (address) => {
        setPairLoading(true)
        //console.log({ address })

        try {
            //const res = await fetch('https://www.dextools.io/chain-ethereum/api/pair/search?s=' + address);
            const res = await fetch('/api/fetchPair?address=' + address);
            const tmp = await res.json();
            setPair(tmp)
        } catch (e) {
            setPair(false)
        }

        //console.log({ tmp })
        //setContracts(tmp.records);
        setPairLoading(false)
    }


    const fetchContractDetails = async () => {
        setLoading(true)
        //console.log({ address })

        try {
            const res = await fetch('https://api.opensea.io/api/v1/asset_contract/' + address);
            const tmp = await res.json();
            setContract(tmp)
            if (tmp.schema_name == 'ERC20') {
                fetchPairStats(address)
            }
        } catch (e) {
            setContract(false)
        }

        //console.log({ tmp })
        //setContracts(tmp.records);
        setLoading(false)

    }

    useEffect(() => {
        fetchContractDetails();
    }, [address]);

    if (loading) {
        return <Spin />
    }
    if (contract == false) {
        return <div>Unable to fetch details!</div>
    }
    return (

        <div>
            <Row>
                <Col span={3}>
                    {contract.schema_name == 'ERC20' ? <FaEthereum size="120" /> : null}
                    {contract.schema_name == 'ERC721' ? contract.collection && contract.collection.image_url != null ? <img src={contract.collection.image_url} /> : <FaEthereum size="120" /> : null}
                </Col>
                <Col span={21}>
                    Type: {contract.schema_name} <br />
                    Name: {contract.name}<br />
                    Symbol: {contract.symbol}<br />
                    Total Supply: {contract.total_supply}<br />
                    {contract.schema_name == 'ERC20' && pairLoading ? <Spin size="small" /> : pair && pair.stats && pair.stats.length > 0 ? <a target="_blank" href={"https://dextools.io/app/ether/pair-explorer/" + pair.stats[0].id}>Pair analytics (from DexTools)</a> : null}
                </Col>


            </Row>

            <ReactMarkdown linkTarget="_blank">{contract.collection ? contract.collection.description : null}</ReactMarkdown>

            <div>
            <a style={{ marginRight: "10px" }} target="_blank" href={"https://tokensniffer.com/token/" + address} title="TokenSniffer"><FaShieldAlt size="2em" style={{ color: "rgb(235 63 0)" }} /></a>
            
            {contract.schema_name == 'ERC721' ? <span>

                {contract.external_link != null ? <a style={{ marginRight: "10px" }} target="_blank" href={contract.external_link}><FaGlobe size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}

                {contract.collection && contract.collection.slug != null ? <a style={{ marginRight: "10px" }} target="_blank" href={"https://opensea.io/collection/" + contract.collection.slug}><GiSailboat size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}

                {contract.collection && contract.collection.twitter_username != null ? <a style={{ marginRight: "10px" }} target="_blank" href={"https://twitter.com/" + contract.collection.twitter_username}><FaTwitter size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}

                {contract.collection && contract.collection.discord_url != null ? <a style={{ marginRight: "10px" }} href={contract.collection.discord_url} target="_blank"><FaDiscord size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}
                {contract.collection && contract.collection.instagram_username != null ? <a style={{ marginRight: "10px" }} href={"https://instagram.com/" + contract.collection.instagram_username} target="_blank"><FaInstagram size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}
                {contract.collection && contract.collection.telegram_url != null ? <a style={{ marginRight: "10px" }} href={contract.collection.telegram_url} target="_blank"><FaTelegram size="2em" style={{ color: "rgb(235 63 0)" }} /></a> : null}




            </span> : null}
            </div>
        </div>
    );
}

export default ContractDetails;